import EmptyView from "common/Empty/EmptyView";
import {
  BACKTESTING_EXTRA_DETAILS_PATH,
  CREATE_TRADE_PATH,
} from "common/constants";
import React, { CSSProperties, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  closedTradesFilters,
  openTradesFilters,
} from "@shared/slices/filters.slice";
import NoExchangeConnectedModal from "features/configuration/common/NoExchangeConnectedModal";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import {
  useSelectUser,
  useSubUserPermissions,
} from "@shared/utils/hooks/misc.ts";

interface TradesEmptyProps {
  isOpenTrades: boolean;
  iconWidth: number;
  isSearch?: boolean;
  openFilters?: () => void;
  filtersChipsOpen?: string;
  hasData?: boolean;
  titleStyle?: CSSProperties;
  buttonStyle?: CSSProperties;
  style?: CSSProperties;
}

const TradesEmpty = ({
  isOpenTrades,
  iconWidth,
  isSearch,
  openFilters,
  filtersChipsOpen,
  hasData,
  titleStyle,
  buttonStyle,
  style,
}: TradesEmptyProps) => {
  const isBacktesting = !!useRouteMatch(BACKTESTING_EXTRA_DETAILS_PATH);
  const history = useHistory();
  const user = useSelectUser();
  const [noExchangeModalVisible, setNoExchangeModalVisible] = useState(false);
  const { isSubUser } = useSubUserPermissions();

  const onButtonClick = () =>
    user?.has_valid_clients_connected
      ? history.push(CREATE_TRADE_PATH)
      : setNoExchangeModalVisible(true);
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);

  return (
    <>
      <EmptyView
        iconKey={EmptyStatesType.Trades}
        title={t("empty.no_trades_title", {
          status: t(isOpenTrades ? "tabs.open" : "tabs.closed").toLowerCase(),
        })}
        buttonText={
          isBacktesting || isSubUser || user?.isWhopExperience()
            ? undefined
            : t("actions.create_trade")
        }
        buttonOnClick={isBacktesting ? undefined : onButtonClick}
        iconWidth={iconWidth}
        objectName={t("empty.object_name", {
          status: t(isOpenTrades ? "tabs.open" : "tabs.closed").toLowerCase(),
        })}
        filtersSlice={isOpenTrades ? openTradesFilters : closedTradesFilters}
        isSearch={isSearch}
        openFilters={openFilters}
        filtersChipsOpen={filtersChipsOpen}
        hasData={hasData}
        titleStyle={titleStyle}
        buttonStyle={buttonStyle}
        style={style}
      />
      <NoExchangeConnectedModal
        placement="trades_empty"
        onClose={() => setNoExchangeModalVisible(false)}
        open={noExchangeModalVisible}
        action={t("modals.no_exchange_action_create")}
      />
    </>
  );
};

export default TradesEmpty;
